import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container,
  Button,
  useMediaQuery,
  Grid,
  TextField,
  CircularProgress,
  Tooltip,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,

} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useUser } from "../context/UserContext";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { fetchSoldItemsByDateRange, deleteSingleSoldItem, validatePassword,updateSodlItemAtsingSoldItemAndsoldItem } from "../services/api";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import SpinnerLoading from "../utility/LoadingIndicator"






const SoldItems = () => {
  const [soldItems, setSoldItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { user } = useUser();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalSoldPrice, setTotalSoldPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg")); // For large devices
  const isExtraLargeDevice = useMediaQuery(theme.breakpoints.up("xl"));
  const [password, setPassword] = useState("");
  const [passwordDialogOpen, setPasswordDailogOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [updateData, setUpdateData] = useState({
    itemId: "",
    itemName: "",
    quantity_ml: "",
    sold_stockQuantity: "",
    _id:"",
    sold_cost:"",
    orgId:"",
  });
  

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };




  const calculateTotalValue = (quantity, price) => quantity * price;

  const calculateTotalSoldPrice = () => {
    return filteredSoldItems.reduce(
      (acc, item) => acc + calculateTotalValue(item.sold_stockQuantity, item.sold_cost),
      0
    );
  };

 
  

  const orgId = user.orgId;


  const filteredSoldItems = Array.isArray(soldItems)
    ? soldItems.filter((item) =>
      item.itemName?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];


    useEffect(() => {
      setTotalSoldPrice(calculateTotalSoldPrice());
    }, [filteredSoldItems, searchTerm]);


  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };


  const handleGetItems = async () => {
    setLoading(true);
    setSoldItems([])
    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates.");
      setLoading(false);
      return;
    }

    // Format dates in "YYYY-MM-DD" to preserve local timezone without time shift
    const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

    try {
      const response = await fetchSoldItemsByDateRange(
        formattedStartDate,
        formattedEndDate,
        orgId
      );

      // Log the response to confirm its structure
      console.log("API Response:", response);

      if (response?.data?.success) {
        setSoldItems(response.data.data);
        setLoading(false);
      } 
      else {
        // Display the server-provided message if success is false
        toast.warn(response.data.message || "No data found for this date range.");
        setSoldItems([]);
      }
    } catch (error) {
      // Handle network or server errors
      const errorMessage = error.response?.data?.message || "Failed to fetch sold items.";
      toast.warn(errorMessage);
      setLoading(false);
      console.error("Error fetching sold items:", error);
      setLoading(false);
    }
  };

  // Close dialog
  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  // Confirm delete
  const handleConfirmDelete = async () => {
    if (selectedItem) {
      console.log("Deleting Item:", selectedItem);

      try {
        const itemData = {
          itemName: selectedItem.itemName,
          soldCreatedAt: selectedItem.soldCreatedAt,
          sold_stockQuantity: selectedItem.sold_stockQuantity,
          sold_cost: selectedItem.sold_cost,
          orgId: selectedItem.orgId,
        };

        const response = await deleteSingleSoldItem(itemData);

        if (response.status === 200) {
          toast.success("Item successfully removed!");
          handleGetItems(); // Refresh the item list
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error(
          error.response?.data?.message || "An error occurred while deleting the item."
        );
      }
    }

    handleClose(); 
  };

  // Open confirmation dialog
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setPasswordDailogOpen(true);
  };

  const handleUpdateClick = (item) => {
    console.log(item);
    setUpdateModal(true);
    setSelectedItem(item);
    setUpdateData({
      _id:item._id,
      itemId:item.itemId,
      itemName:item.itemName,
      sold_stockQuantity: item.sold_stockQuantity,
      quantity_ml:item.quantity,
      sold_cost:item.sold_cost,
      orgId:item.orgId,

    });

    console.log(updateData);
  }

  const handleDownloadPdf = () => {
    if (soldItems.length === 0) {
      toast.warn("Please select date ranges!");
      return;
    }

    const doc = new jsPDF();
    const tableColumn = [
      "Item Code",
      "Item Name",
      "Quantity (ml)",
      "Stock Sold",
      "MRP",
      "Total Value",
      "Sold Date",
    ];
    const tableRows = [];

    soldItems.forEach((item) => {
      const rowData = [
        item.itemId,
        item.itemName,
        item.quantity_ml,
        item.sold_stockQuantity,
        item.sold_cost.toFixed(2),
        calculateTotalValue(item.sold_stockQuantity, item.sold_cost).toFixed(2),
        new Date(item.soldCreatedAt).toLocaleDateString("en-IN"),
      ];
      tableRows.push(rowData);
    });

    // Add header information with proper positioning
    doc.setFontSize(12);
    doc.text(`Shop Name: ${user.userName}`, 10, 10);
    doc.text(`Org ID: ${user.orgId}`, 10, 16);
    doc.text(`Report Generated: ${new Date().toLocaleString('en-IN')}`, 10, 22);

    // Title for the report
    doc.setFontSize(14);
    doc.text("Sold Beverage Items History", 14, 30);

    // Table with alignment adjustments
    doc.autoTable({
      startY: 35,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: { fontSize: 10 },
      columnStyles: {
        1: { halign: "center" }, // Quantity (ml)
        2: { halign: "center" }, // Stock Sold
        3: { halign: "center" }, // Price
        4: { halign: "center" }, // Total Value
        5: { halign: "center" }, // Sold Date
      },
      margin: { top: 10 },
    });

    // Add totalSoldPrice below the table
    const finalY = doc.lastAutoTable.finalY || 35; // Get the Y position after the table
    doc.setFontSize(12);
    doc.text(`Total Sold Bill Price: ${totalSoldPrice.toFixed(2)}`, 135, finalY + 10);

    // Save the PDF with a timestamp
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}_${date
        .getHours()
        .toString()
        .padStart(2, "0")}-${date.getMinutes().toString().padStart(2, "0")}-${date
          .getSeconds()
          .toString()
          .padStart(2, "0")}`;
    const fileName = `Sold_Items_History(${formattedDate}).pdf`;
    doc.save(fileName);
  };



  const handlePasswordVerify = async () => {
    try {
      console.log(user.userId);
      const response = await validatePassword(user.userId, password);
      if (response.status === 200) {

        setPasswordDailogOpen(false);
        setOpen(true);
        setPassword("");
      } else {
        toast.error("Password not verified. Please check password and try again.!");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message;

      if (errorMessage === "Invalid credentials.") {
        toast.error("Password not verified. Please check password and try again.");
      } else {
        toast.error(errorMessage || "User ID not found. Please enter correct UserID.");
      }
    }
  };


  const handleUpdate =async () => {
    try{
        const response = await updateSodlItemAtsingSoldItemAndsoldItem(updateData)
        if(response.status == 200){
          toast.success("sold Item records updated successfully...!")
          handleGetItems();
        }
    }
    catch{
      toast.error("Error occured while updatin sold count ...!")

    }

    
    onClose(); 
  };

  const onClose = () => {
    setUpdateModal(false);
  }

  return (

    <>
    <style>
        {`
          @media (min-width: 1200px) {
            .css-5c1adp-MuiContainer-root {
              max-width: 100vw !important;
            }
          }
        `}
      </style>

    <Container maxWidth="lg">
      <ToastContainer />
      <Box>
        <Typography
          sx={{ color: "#024CAA", }}
          variant={isMobile ? "h6" : "h5"}
          gutterBottom
        >
          Sales History
        </Typography>
        <Grid container mb={2} spacing={2} alignItems="center">
          {/* Start Date Picker */}
          <Grid item xs={6} sm={4} md={2}>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              maxDate={new Date()}
              dateFormat="dd-MM-yyyy"
              customInput={
                <TextField
                  label="Start Date"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={startDate ? dayjs(startDate).format("DD-MM-YYYY") : ""}
                  sx={{
                    "& .MuiInputBase-root": { height: "37px" },
                  }}
                />
              }
              popperProps={{ positionFixed: true }}
              wrapperClassName="date-picker-wrapper"
            />
          </Grid>

          {/* End Date Picker */}
          <Grid item xs={6} sm={4} md={2}>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              maxDate={new Date()}
              dateFormat="dd-MM-yyyy"
              customInput={
                <TextField
                  label="End Date"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={endDate ? dayjs(endDate).format("DD-MM-YYYY") : ""}
                  sx={{
                    "& .MuiInputBase-root": { height: "37px" },
                  }}
                />
              }
              popperProps={{ positionFixed: true }}
              wrapperClassName="date-picker-wrapper"
            />
          </Grid>

          {/* Get History Button */}
          <Grid item xs={6} sm={4} md={1.5}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleGetItems}
              sx={{
                height: "100%",
                textTransform: "none",
                background: "#118B50",
              }}
            >
              Get History
            </Button>
          </Grid>

          {/* Search Field */}
          <Grid item xs={6} sm={1} md={1} sx={{width:"50px"}}>
            
          </Grid>
          <Grid item xs={6} sm={1} md={1} sx={{width:"50px"}}>
            
          </Grid>

          <Grid item xs={6} sm={4} md={3}>
            <TextField
              variant="outlined"
              fullWidth
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search by item name"
              sx={{
                input: { color: "#071952", padding: "8px" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#071952" },
                  "&:hover fieldset": { borderColor: "#071952" },
                  "&.Mui-focused fieldset": { borderColor: "#3572EF" },
                
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon style={{ color: "#071952" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {/* History Button */}
          <Grid item xs={6} sm={4} md={1.5}>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              onClick={handleDownloadPdf}
              sx={{
                textTransform: "none",
                background: "#3F52E3",
                paddingRight: "0px 30px 0px 30px",
                // marginLeft: "170px"
              }}
            >
              <GetAppRoundedIcon sx={{ marginRight: "15px" }} />
              History
            </Button>
          </Grid>
        </Grid>
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: isExtraLargeDevice
              ? 480 // Height for extra-large devices
              : isLargeDevice
                ? 420 // Height for large devices
                : 370, // Default height for other devices
            maxWidth: isExtraLargeDevice ? "100vw" : "none", // Max-width cap for XL
            margin: isExtraLargeDevice ? "0 auto" : "inherit", // Center for XL
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            "&::-webkit-scrollbar": {
              width: "6px",
              height: "6px",
            },
            "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "6px",
            },
            "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
          }}
        >
          <Table>
            <TableHead >
              <TableRow>
                {[
                  "Item Code",
                  "Item Name",
                  "Quantity (ml)",
                  "Sales Quantity",
                  "MRP",
                  "Total Value",
                  "Sales Date",
                  ...(user.role === "owner" ? ["Actions"] : "")
                ].map((header) => (
                  <TableCell
                    key={header}
                    align="center"
                    sx={{
                      color: "white",
                      backgroundColor: "#133E87",
                      fontWeight: "bold",
                      
                    }}
                    minWidth={header === "Total Value" && "200px"}
                    
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>

            </TableHead>
            <TableBody>{loading ? (<TableRow>
              <TableCell colSpan={user.role === "owner" ? 8 : 7} align="center">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="50px"
                >
                  <SpinnerLoading color="primary" />
                </Box>
              </TableCell>
            </TableRow>) :
              filteredSoldItems.length > 0 ? (
                filteredSoldItems.reverse().map((item) => (
                  <TableRow key={item.sold_itemId}>
                    <TableCell align="center">{item.itemId}</TableCell>
                    <TableCell align="center" >{item.itemName}</TableCell>
                    <TableCell align="center">{item.quantity_ml}ml</TableCell>
                    <TableCell align="center">
                      {item.sold_stockQuantity}
                    </TableCell>
                    <TableCell align="center">
                      ₹ {item.sold_cost.toFixed(2)}
                    </TableCell>
                    <TableCell align="center" sx={{minWidth:"200px"}}>
                      ₹ {calculateTotalValue(
                        item.sold_stockQuantity,
                        item.sold_cost
                      ).toFixed(2)}
                    </TableCell>
                    <TableCell align="center">
                      {new Date(item.soldCreatedAt).toLocaleDateString("en-IN")}
                    </TableCell>
                    {user.role === "owner" ? (<TableCell align="center" sx={{minWidth:"150px"}}>
                      <Tooltip title="Update">
                        <IconButton onClick={() => handleUpdateClick(item)}>
                          <EditIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton onClick={() => handleDeleteClick(item)}>
                          <DeleteIcon color="error" />
                        </IconButton>
                      </Tooltip>

                    </TableCell>) : ("")}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={user.role === "owner" ? 9 : 8}
                    align="center"
                    sx={{ color: "#133E87" }}
                  >
                    No sales history found.
                  </TableCell>
                </TableRow>
              )}
              <TableRow
                sx={{
                  backgroundColor: "#1450A3",
                  fontWeight: "bold",
                }}
              >
                <TableCell sx={{ textAlign: "center", color: "white" }}>
                  {""}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", color: "white" }}
                ></TableCell>
                <TableCell sx={{ textAlign: "center", color: "white" }}>
                  {""}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", color: "white" }}
                ></TableCell>
                <TableCell
                  sx={{ textAlign: "center", color: "white" }}
                ></TableCell>
                <TableCell sx={{  color: "#FEEC37", fontSize: "16px", fontWeight: "bold",minWidth:"200px" }}>
                  Total : ₹ {totalSoldPrice}/-
                </TableCell>
                <TableCell sx={{ textAlign: "center", color: "white" }}>
                  {""}
                </TableCell>
                {user.role === "owner" ? (<TableCell sx={{ textAlign: "center", color: "white" }}>
                  {""}
                </TableCell>) : ("")}

              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={updateModal} onClose={onClose}
         PaperProps={{
          sx:{
            width:"400px",
            margin:"auto",
            borderRadius:"8px"
          }
         }}
        >
          <DialogTitle color="primary">Update Item</DialogTitle>
          <DialogContent>
            <TextField
              label="Item Code"
              fullWidth
              variant="outlined"
              size="small"
              value={selectedItem?.itemId}
              disabled
              sx={{ marginBottom: 2, marginTop: 1 }}
            />
            <TextField
              label="Item Name"
              fullWidth
              variant="outlined"
              size="small"
              value={selectedItem?.itemName}
              disabled
              sx={{ marginBottom: 2 }}
            />
            <TextField
              label="Quantity (ml)"
              fullWidth
              variant="outlined"
              size="small"
              type="number"
              value={selectedItem?.quantity_ml}
              disabled
              sx={{ marginBottom: 2 }}
            />
            <TextField
              label="Sales Quantity"
              fullWidth
              variant="outlined"
              size="small"
              type="number"
              value={updateData?.sold_stockQuantity || ""}
              onChange={(e) => setUpdateData({
                ...updateData,
                sold_stockQuantity: Number(e.target.value), // Convert input to a number
              })}
              sx={{ marginBottom: 2 }}
            />

            <TextField
              label="Sales Date"
              fullWidth
              variant="outlined"
              size="small"
              type="date"
              value={selectedItem?.soldCreatedAt ? dayjs(selectedItem?.soldCreatedAt).format("YYYY-MM-DD") : ""}
              disabled
              sx={{ marginBottom: 1 }}
            />
          </DialogContent>
          <DialogActions sx={{margin:"0px 15px 20px 0px"}}>
            <Button onClick={onClose} color="primary" variant="outlined">
              Cancel
            </Button>
            <Button onClick={handleUpdate} color="primary" variant="contained">
              Update
            </Button>
          </DialogActions>
        </Dialog>

        {/* Verify Password Modal */}
        <Dialog
          open={passwordDialogOpen}
          onClose={() => setPasswordDailogOpen(false)}
          sx={{ borderRadius: "10px" }}
        >
          <DialogTitle style={{ color: "#006BFF" }}>Verify Password</DialogTitle>
          <DialogContent>
            <TextField
              sx={{ marginTop: "5px" }}
              label="Password"
              fullWidth
              size="small"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </DialogContent>
          <DialogActions sx={{ margin: "10px 14px 10px 0px " }}>
            <Button variant="outlined" onClick={() => setPasswordDailogOpen(false)} sx={{ textTransform: "none" }}>Cancel</Button>
            <Button variant="contained" onClick={handlePasswordVerify} color="primary" sx={{ textTransform: "none" }}>
              Verify
            </Button>
          </DialogActions>
        </Dialog>

        {/* Confirmation Dialog */}
        <Dialog open={open} onClose={handleClose}
          sx={{
            '& .MuiDialog-paper': {
              width: '400px', // Set the desired width
              maxWidth: '90%', // Adjust for responsiveness
              paddingBottom: '20px',
              paddingRight: "20px", borderRadius: "8px"
            },
          }}
        >
          <DialogTitle sx={{ color: "#EB8317" }}>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this item? This action cannot be
              undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined" >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              color="primary"
              variant="contained"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

      </Box>
    </Container>
    </>
  );
};

export default SoldItems;

